import { render } from "./ModalRemove.vue?vue&type=template&id=1dc58198&scoped=true"
import script from "./ModalRemove.vue?vue&type=script&lang=js"
export * from "./ModalRemove.vue?vue&type=script&lang=js"

import "./ModalRemove.vue?vue&type=style&index=0&id=1dc58198&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc58198"]])

export default __exports__